<template>
  <div class="m-login-callback">
    <AtomLoadingPrimary/>
  </div>
</template>

<script>
import auth0 from 'auth0-js'
import configApp from '@/config'

export default {
  name: 'MoleculeClearCache',

  data () {
    return {
      academy: '',

      currentAcademy: '',

      cookieArray: Array
    }
  },

  created () {
    this.currentAcademy = JSON.parse(localStorage.getItem('current_academy'))
    if (this.currentAcademy === null || this.currentAcademy === 'undefined') {
      this.academy = 'https://vidroop.com'
    } else {
      this.academy = `${configApp.marketPlaceDomain}/${this.currentAcademy.url}`
    }

    // borrar localstore
    localStorage.removeItem('access_token')
    localStorage.removeItem('actor')
    localStorage.removeItem('current_url')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('id_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user')

    // borrar store
    this.$store.commit('unsetSession')
    this.$store.commit('unsetAcademyData')
    this.$store.commit('unsetActorData')

    // borrar cookie que contengan en su name auth0 o did
    this.cookieArray = document.cookie.split(';')
    this.cookieArray.forEach(element => {
      let key = element.split('=', 1)[0]
      console.log(key)
      if (key.indexOf('auth0') !== -1 || key.indexOf('did') !== -1) {
        document.cookie = key.replace(/ /g, '') + '=;max-age=0;path=/'
      }
    })

    // instanciamos auth0
    let webAuth = new auth0.WebAuth({
      domain: configApp.authDomain,
      clientID: configApp.authClientId,
      redirectUri: configApp.authCallbackUrl,
      audience: configApp.apiUrl,
      responseType: 'token id_token',
      scope: ''
    })

    // cerramos la sesion de la aplicacion
    webAuth.logout({
      returnTo: `${configApp.appDomain}/return-to?academy=${this.academy}`
    })
  }
}
</script>
